(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
!function(e,o){if("function"==typeof define&&define.amd)define(["exports"],o);else if("undefined"!=typeof exports)o(exports);else{var t={};o(t),e.bodyScrollLock=t}}(this,function(exports){"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var t=!1;if("undefined"!=typeof window){var e={get passive(){t=!0}};window.addEventListener("testPassive",null,e),window.removeEventListener("testPassive",null,e)}function l(o){return c.some(function(e){return!(!e.options.allowTouchMove||!e.options.allowTouchMove(o))})}function d(e){var o=e||window.event;return!!l(o.target)||(1<o.touches.length||(o.preventDefault&&o.preventDefault(),!1))}function n(){void 0!==v&&(document.body.style.paddingRight=v,v=void 0),void 0!==s&&(document.body.style.overflow=s,s=void 0)}var i="undefined"!=typeof window&&window.navigator&&window.navigator.platform&&(/iP(ad|hone|od)/.test(window.navigator.platform)||"MacIntel"===window.navigator.platform&&1<window.navigator.maxTouchPoints),c=[],a=!1,u=-1,s=void 0,v=void 0;exports.disableBodyScroll=function(r,e){if(r){if(!c.some(function(e){return e.targetElement===r})){var o={targetElement:r,options:e||{}};c=[].concat(function(e){if(Array.isArray(e)){for(var o=0,t=Array(e.length);o<e.length;o++)t[o]=e[o];return t}return Array.from(e)}(c),[o]),i?(r.ontouchstart=function(e){1===e.targetTouches.length&&(u=e.targetTouches[0].clientY)},r.ontouchmove=function(e){var o,t,n,i;1===e.targetTouches.length&&(t=r,i=(o=e).targetTouches[0].clientY-u,l(o.target)||(t&&0===t.scrollTop&&0<i||(n=t)&&n.scrollHeight-n.scrollTop<=n.clientHeight&&i<0?d(o):o.stopPropagation()))},a||(document.addEventListener("touchmove",d,t?{passive:!1}:void 0),a=!0)):function(e){if(void 0===v){var o=!!e&&!0===e.reserveScrollBarGap,t=window.innerWidth-document.documentElement.clientWidth;o&&0<t&&(v=document.body.style.paddingRight,document.body.style.paddingRight=t+"px")}void 0===s&&(s=document.body.style.overflow,document.body.style.overflow="hidden")}(e)}}else console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.")},exports.clearAllBodyScrollLocks=function(){i?(c.forEach(function(e){e.targetElement.ontouchstart=null,e.targetElement.ontouchmove=null}),a&&(document.removeEventListener("touchmove",d,t?{passive:!1}:void 0),a=!1),u=-1):n(),c=[]},exports.enableBodyScroll=function(o){o?(c=c.filter(function(e){return e.targetElement!==o}),i?(o.ontouchstart=null,o.ontouchmove=null,a&&0===c.length&&(document.removeEventListener("touchmove",d,t?{passive:!1}:void 0),a=!1)):c.length||n()):console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.")}});

},{}],2:[function(require,module,exports){
/*! js-cookie v3.0.1 | MIT */
;
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, (function () {
    var current = global.Cookies;
    var exports = global.Cookies = factory();
    exports.noConflict = function () { global.Cookies = current; return exports; };
  }()));
}(this, (function () { 'use strict';

  /* eslint-disable no-var */
  function assign (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        target[key] = source[key];
      }
    }
    return target
  }
  /* eslint-enable no-var */

  /* eslint-disable no-var */
  var defaultConverter = {
    read: function (value) {
      if (value[0] === '"') {
        value = value.slice(1, -1);
      }
      return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
    },
    write: function (value) {
      return encodeURIComponent(value).replace(
        /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
        decodeURIComponent
      )
    }
  };
  /* eslint-enable no-var */

  /* eslint-disable no-var */

  function init (converter, defaultAttributes) {
    function set (key, value, attributes) {
      if (typeof document === 'undefined') {
        return
      }

      attributes = assign({}, defaultAttributes, attributes);

      if (typeof attributes.expires === 'number') {
        attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
      }
      if (attributes.expires) {
        attributes.expires = attributes.expires.toUTCString();
      }

      key = encodeURIComponent(key)
        .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
        .replace(/[()]/g, escape);

      var stringifiedAttributes = '';
      for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
          continue
        }

        stringifiedAttributes += '; ' + attributeName;

        if (attributes[attributeName] === true) {
          continue
        }

        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
      }

      return (document.cookie =
        key + '=' + converter.write(value, key) + stringifiedAttributes)
    }

    function get (key) {
      if (typeof document === 'undefined' || (arguments.length && !key)) {
        return
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all.
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var jar = {};
      for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var value = parts.slice(1).join('=');

        try {
          var foundKey = decodeURIComponent(parts[0]);
          jar[foundKey] = converter.read(value, foundKey);

          if (key === foundKey) {
            break
          }
        } catch (e) {}
      }

      return key ? jar[key] : jar
    }

    return Object.create(
      {
        set: set,
        get: get,
        remove: function (key, attributes) {
          set(
            key,
            '',
            assign({}, attributes, {
              expires: -1
            })
          );
        },
        withAttributes: function (attributes) {
          return init(this.converter, assign({}, this.attributes, attributes))
        },
        withConverter: function (converter) {
          return init(assign({}, this.converter, converter), this.attributes)
        }
      },
      {
        attributes: { value: Object.freeze(defaultAttributes) },
        converter: { value: Object.freeze(converter) }
      }
    )
  }

  var api = init(defaultConverter, { path: '/' });
  /* eslint-enable no-var */

  return api;

})));

},{}],3:[function(require,module,exports){
"use strict";

require("./app/_init");

require("./app/btnUp");

require("./app/mobile-menu");

require("./app/menu-top");

require("./app/modal");

require("./app/form");

require("./app/inputs");

require("./app/slider");

require("./app/glossary");

require("./app/cookies");

require("./app/filter");

require("./app/accordion");

require("./app/load-more");

require("./app/header");

require("./app/rating");

},{"./app/_init":4,"./app/accordion":5,"./app/btnUp":6,"./app/cookies":7,"./app/filter":8,"./app/form":9,"./app/glossary":10,"./app/header":11,"./app/inputs":12,"./app/load-more":13,"./app/menu-top":14,"./app/mobile-menu":15,"./app/modal":16,"./app/rating":17,"./app/slider":18}],4:[function(require,module,exports){
"use strict";

},{}],5:[function(require,module,exports){
"use strict";

var expandTogglers = document.querySelectorAll('[data-toggler="expand"]') || [];
expandTogglers.forEach(function (item) {
  var textContainer = item.querySelector('[data-toggle-text]');
  var innerTags = document.querySelector('.accordion__menu--tag');

  if (innerTags) {
    var mounter = function mounter() {
      if (window.innerWidth > 998) {
        innerTags.classList.add('collapse');
      } else if (window.innerWidth < 998) {
        innerTags.classList.remove('collapse');
      }
    };

    window.addEventListener('resize', mounter);
  }

  var expandAction = function expandAction() {
    var target = item.getAttribute('data-target');
    var targetItem = document.querySelector('[data-target-item=' + target + ']');
    var innerCards = targetItem.querySelectorAll('.card') || [];
    item.classList.toggle('active');
    targetItem.classList.toggle('collapse');
    innerCards.forEach(function (card) {
      return card.classList.toggle('show');
    });

    if (textContainer) {
      var currentText = textContainer.innerText;
      textContainer.innerText = textContainer.getAttribute('data-toggle-text');
      textContainer.setAttribute('data-toggle-text', currentText);
    }
  };

  item.addEventListener('click', function () {
    return expandAction();
  });
  item.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      expandAction();
    }
  });
});

},{}],6:[function(require,module,exports){
"use strict";

var btnUp = document.querySelector('.btn__up');

if (btnUp) {
  window.addEventListener('scroll', function () {
    var scrolled = window.pageYOffset;
    var btnPosition = document.documentElement.clientHeight - 500;
    btnUp.classList[scrolled > btnPosition ? 'add' : 'remove']('show');
  });
  btnUp.addEventListener('click', backToTop);
}

function backToTop() {
  if (window.pageYOffset > 0) {
    window.scrollBy(0, -80);
    setTimeout(backToTop, 0);
  }
}

},{}],7:[function(require,module,exports){
"use strict";

var _jsCookie = _interopRequireDefault(require("js-cookie"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

window.onload = function () {
  var cookies = document.querySelector('#cookiesMessage');

  if (cookies) {
    cookies.querySelector('[data-toggle="cookies-accept"]').addEventListener('click', function () {
      cookies.classList.add('hide');
      setTimeout(function () {
        cookies.remove();
      }, 1000);

      _jsCookie["default"].set('vase_cookies', 'accept', {
        expires: 365
      });
    });
  }
};

},{"js-cookie":2}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showOverlay = exports.hideOverlay = exports.getFilterFields = void 0;

var _greatSelect = _interopRequireDefault(require("../modules/great-select"));

var _constants = require("../modules/_constants");

var _ajaxHandler = _interopRequireDefault(require("../modules/ajax-handler"));

var _functions = require("../modules/_functions");

var _bodyScrollLock = require("body-scroll-lock");

var _modal = require("./modal");

var _form = require("./form");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var overlay = _modal.body.querySelector('.overlay');

var loader = _modal.header.querySelector('.loader');

var loaderProgress = _modal.header.querySelector('.loader__progress');

var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
var gSelect = new _greatSelect["default"]('[data-select]', _constants.SELECT);
gSelect.init();
var filterForm = document.querySelector('.form--filter');

if (filterForm) {
  var controls = filterForm.querySelectorAll('select, input');

  var updateCards = function updateCards(e) {
    if (e.target.checked === true) {
      if (e.target.value === 'all') {
        var tagsWithoutAll = Array.prototype.filter.call(controls, function (item) {
          return item.getAttribute('id') !== 'all';
        });
        tagsWithoutAll.forEach(function (tag) {
          return tag.checked = false;
        });
      } else {
        var allButton = Array.prototype.find.call(controls, function (item) {
          return item.getAttribute('id') === 'all';
        });
        allButton.checked = false;
      }
    }

    var url = '/ajax/';
    var formData = new FormData(filterForm);
    var fields = getFilterFields(filterForm);
    formData.append('filters', JSON.stringify(fields));
    var ajax = new _ajaxHandler["default"]({
      'url': url,
      'form': filterForm
    });

    var loadContainer = _modal.body.querySelector(_constants.LOAD_MORE.container); // showOverlay();


    ajax.send(formData, function () {
      var response = ajax.response;
      loadContainer.textContent = '';

      if (response['cards']) {
        loadContainer.insertAdjacentHTML('beforeend', response['cards']);
      } else {
        loadContainer.insertAdjacentHTML('beforeend', '<div class="load-message">Не найдено</div>');
      }

      var loadMore = loadContainer.closest(_constants.LOAD_MORE.parent).querySelector('[data-toggle="loadMore"]');

      if (loadMore) {
        if (ajax.response.found_posts <= ajax.response.post_count) {
          loadMore.style.display = 'none';
        } else {
          loadMore.style.display = 'block';
        }
      }

      hideOverlay();
    });
  };

  controls.forEach(function (select) {
    return select.addEventListener('change', updateCards);
  });
}

var getFilterFields = function getFilterFields(form) {
  var multipleValues = form.querySelectorAll('[data-value="multiple"]:checked');
  var controls = form.querySelectorAll('select');

  var filters = _toConsumableArray(controls).reduce(function (acc, control) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, control.name, control.value));
  }, {});

  if (multipleValues.length) {
    var fieldName = multipleValues[0].dataset.name;
    filters[fieldName] = multipleValues.length > 1 ? _toConsumableArray(multipleValues).filter(function (input) {
      return input.value !== 'all';
    }).map(function (input) {
      return input.value;
    }) : [multipleValues[0].value];
  }

  return filters;
};

exports.getFilterFields = getFilterFields;
var animation;
var start;

var progress = function progress(timestamp) {
  if (start === undefined) start = timestamp;
  var elapsed = timestamp - start;
  loaderProgress.style.width = elapsed / 15 + '%';

  if (elapsed < 900) {
    animation = window.requestAnimationFrame(progress);
  }
};

var showOverlay = function showOverlay() {
  if (!(0, _functions.isMobileDevice)()) {
    _modal.body.classList.add('modal-open');

    _modal.body.style.paddingRight = scrollbarWidth + 'px';
    _modal.header.style.right = scrollbarWidth + 'px';
  }

  if ((0, _functions.isMobileDevice)()) {
    (0, _bodyScrollLock.disableBodyScroll)(overlay, {
      reserveScrollBarGap: true
    });
  }

  start = undefined;
  loaderProgress.style.width = 0;
  setTimeout(function () {
    overlay.classList.add('show');
    loader.classList.add('show');
    animation = window.requestAnimationFrame(progress);
  }, 200);
};

exports.showOverlay = showOverlay;

var hideOverlay = function hideOverlay() {
  window.cancelAnimationFrame(animation);
  overlay.classList.add('out');

  if ((0, _functions.isMobileDevice)()) {
    (0, _bodyScrollLock.enableBodyScroll)(overlay);
  }

  setTimeout(function () {
    (0, _form.setFormDefaults)(false, overlay);
    overlay.classList.remove('show');
    overlay.classList.remove('out');

    _modal.body.classList.remove('modal-open');

    _modal.body.style.paddingRight = null;
    _modal.header.style.right = null;
    loaderProgress.style.width = '100%';
  });
  overlay.addEventListener('transitionend', function () {
    loader.classList.remove('show');
  }, {
    once: true
  });
};

exports.hideOverlay = hideOverlay;

},{"../modules/_constants":19,"../modules/_functions":20,"../modules/ajax-handler":21,"../modules/great-select":23,"./form":9,"./modal":16,"body-scroll-lock":1}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setFormDefaults = setFormDefaults;

var _constants = require("../modules/_constants");

var _ajaxHandler = _interopRequireDefault(require("../modules/ajax-handler"));

var _ctaGoals = require("../modules/cta-goals");

var _modal = require("./modal");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var forms = document.querySelectorAll('.form') || [];
forms.forEach(function (item) {
  var inputs = item.querySelectorAll(_constants.FORM.control);
  inputs.forEach(function (input) {
    return input.addEventListener('focus', function (e) {
      clearInputError(e.target);
    });
  });
  item.addEventListener('submit', function (e) {
    e.preventDefault();
    var form = e.target;
    var url = form.getAttribute('action');
    var formData = new FormData(form);
    var inputs = form.querySelectorAll(_constants.FORM.control);
    var fileInput = form.querySelector('input[type="file"]');
    var ajax = new _ajaxHandler["default"]({
      'url': url,
      'form': form
    });
    var csrfToken = document.getElementById('csrf-token');

    if (csrfToken) {
      formData.append('csrf_token', csrfToken.getAttribute('content'));
    }

    if (fileInput) {
      for (var i = 0; i < fileInput.files.length; i++) {
        formData.append('files[]', fileInput.files[i]);
      }
    }

    inputs.forEach(function (input) {
      return clearInputError(input);
    });
    ajax.send(formData, function () {
      var response = ajax.response;
      inputs.forEach(function (input) {
        return input.value = '';
      });
      (0, _ctaGoals.reachGoals)(response.counters.ym_goal, response.counters.gads_goal, response.counters.ga4_goal);

      if ('success_modal' === response.type) {
        var currentModal = form.closest(_constants.MODAL.module);

        if (!currentModal) {
          var currentResponse = document.getElementById(_constants.MODAL.successId).querySelector(_constants.MODAL.response);
          currentResponse.innerHTML = response.message;
          currentResponse.classList.add('show');
          (0, _modal.openModal)(_constants.MODAL.successId);
          setFormDefaults(form);
        } else if (currentModal) {
          var _currentResponse = currentModal.querySelector(_constants.MODAL.response);

          currentModal.querySelector(_constants.MODAL.content).classList.add('hide');

          _currentResponse.classList.add('show');

          _currentResponse.innerHTML = response.message;
        }
      } else {
        localStorage.setItem('fromPage', window.location.pathname);
        window.location.replace('https://' + window.location.hostname + _constants.SUCCESS_PAGE);
      }
    }, function () {
      onResponseFalse(form, ajax.response);
    });
    e.preventDefault();
  });
});

function onResponseFalse(form, response) {
  var inputs = form.querySelectorAll(_constants.FORM.control);
  inputs.forEach(function (input) {
    var errorMsg = input.parentElement.querySelector(_constants.FORM.error);
    var field = input.closest(_constants.FORM.field);

    for (var error in response.errors) {
      if (input.name === response.errors[error].field && !errorMsg) {
        field.classList.add('error');
        input.classList.add('error');
        input.insertAdjacentHTML('afterend', '<span class="error-msg">' + response.errors[error].message + '</span>');
      }
    }
  });
}

function clearInputError(input) {
  var field = input.closest(_constants.FORM.field);

  if (field.classList.contains('error')) {
    var errorMsg = input.parentElement.querySelector(_constants.FORM.error);
    field.classList.remove('error');
    input.classList.remove('error');

    if (errorMsg) {
      input.parentElement.removeChild(errorMsg);
    }
  }
}

function setFormDefaults(form, modal) {
  if (modal) {
    var formResponse = modal.querySelector(_constants.MODAL.response);
    var modalContent = modal.querySelector(_constants.MODAL.content);

    if (modalContent) {
      setTimeout(function () {
        modal.querySelector(_constants.MODAL.content).classList.remove('hide');
      }, 200);
    }

    if (formResponse) {
      formResponse.innerHTML = '';
    }

    form = modal.querySelector('.form');
  }

  if (form) {
    form.querySelectorAll(_constants.FORM.control).forEach(function (input) {
      return clearInputError(input);
    });
  }
}

},{"../modules/_constants":19,"../modules/ajax-handler":21,"../modules/cta-goals":22,"./modal":16}],10:[function(require,module,exports){
"use strict";

var categories = document.querySelectorAll('.glossary-link:not(.disabled)') || [];
var allItems = document.querySelectorAll('.glossary-item') || [];
var glossaryBody = document.querySelector('.glossary-body');

if (glossaryBody) {
  var minHeight;

  var glossaryListener = function glossaryListener(e, links, allItems) {
    var category = e.target.getAttribute('data-letter');
    links.forEach(function (linkInner) {
      linkInner.classList.remove('active');

      if (linkInner.getAttribute('data-letter') === category) {
        linkInner.classList.add('active');
      }
    });

    if (category !== 'all') {
      glossaryBody.classList.add('active');
      allItems.forEach(function (item) {
        item.classList.remove('active');
        item.classList.add('inactive');
      });
      setTimeout(function () {
        var activeItems = glossaryBody.querySelectorAll('[data-letter=' + category + ']');
        activeItems.forEach(function (item) {
          item.classList.remove('inactive');
          item.classList.add('active');
        });
        glossaryBody.removeAttribute('style');
        minHeight = glossaryBody.offsetHeight;
        glossaryBody.style.minHeight = minHeight + 'px';
      }, 100);
    } else {
      glossaryBody.classList.remove('active');
      allItems.forEach(function (catItem) {
        catItem.classList.remove('inactive');
        catItem.classList.add('active');
      });
      minHeight = glossaryBody.offsetHeight;
      glossaryBody.style.minHeight = minHeight + 'px';
    }

    e.preventDefault();
  };

  categories.forEach(function (link) {
    link.addEventListener('click', function (e) {
      glossaryListener(e, categories, allItems);
    });
  });
}

},{}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeLightHeader = exports.makeDarkHeader = void 0;

var _jsCookie = _interopRequireDefault(require("js-cookie"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var body = document.body;
var header = document.querySelector('.header');
var logo = header.querySelector('.header__logo');
var menuLinks = header.querySelectorAll('.menu__link');
var burger = header.querySelector('.header__burger');
var headerButton = header.querySelector('[data-toggle="modal"]');
var theme = header.dataset.theme;
var topLine = document.querySelector('.topline');
var mainBlock = document.querySelector('.main');

var makeLightHeader = function makeLightHeader() {
  if (!header.classList.contains('header--light')) {
    header.classList.replace('header--dark', 'header--light');
    logo.classList.replace('header__logo--dark', 'header__logo--light');
    menuLinks.forEach(function (item) {
      item.classList.replace('menu__link--dark', 'menu__link--light');
    });

    if (burger) {
      burger.classList.replace('burger--dark', 'burger--light');
    }

    if (headerButton) {
      headerButton.classList.replace('btn--dark', 'btn--light');
    }
  }
};

exports.makeLightHeader = makeLightHeader;

var makeDarkHeader = function makeDarkHeader() {
  if (theme === 'dark') {
    header.classList.replace('header--light', 'header--dark');
    logo.classList.replace('header__logo--light', 'header__logo--dark');
    menuLinks.forEach(function (item) {
      item.classList.replace('menu__link--light', 'menu__link--dark');
    });

    if (burger) {
      burger.classList.replace('burger--light', 'burger--dark');
    }

    if (headerButton) {
      headerButton.classList.replace('btn--light', 'btn--dark');
    }
  }
};

exports.makeDarkHeader = makeDarkHeader;

if (topLine) {
  var topLineCloseBtn = topLine.querySelector('[data-toggle="close"]');

  _jsCookie["default"].remove('topline_post_id');

  var topLineHeight = topLine.offsetHeight;
  body.style.paddingTop = topLineHeight + 'px';
  topLineCloseBtn.addEventListener('click', function () {
    var postId = topLine.dataset.postId;

    _jsCookie["default"].set('topline_post_id', String(postId), {
      expires: 7,
      path: '/'
    });

    topLine.classList.add('hide');
    mainBlock.classList.remove('main--topline');
    body.style.paddingTop = '0';
    topLine.addEventListener('transitionend', function () {
      if (topLine) {
        topLine.remove();
        topLine = null;
      }
    });
  });
}

},{"js-cookie":2}],12:[function(require,module,exports){
"use strict";

var inputs = document.querySelectorAll('.form__control') || [];

var inputFocus = function inputFocus(e) {
  var input = e.target;
  var inputControl = input.closest('.form__field');
  inputControl.classList.add('focused');
};

var inputBlur = function inputBlur(e) {
  var input = e.target;
  var inputControl = input.closest('.form__field');
  inputControl.classList.remove('focused');

  if (input.value !== '') {
    inputControl.classList.add('filled');
    inputControl.classList.remove('error');
  } else {
    inputControl.classList.remove('filled');
  }
};

var inputTyping = function inputTyping(e) {
  var input = e.target;
  var inputControl = input.closest('.form__field');
  var errorMsg = inputControl.querySelector('.error-msg');
  inputControl.classList.remove('error');

  if (errorMsg) {
    errorMsg.remove();
  }
};

if (inputs.length) {
  inputs.forEach(function (item) {
    setInputListeners(item);
  });
}

function setInputListeners(input) {
  input.addEventListener('focus', inputFocus);
  input.addEventListener('blur', inputBlur);
  input.addEventListener('input', inputTyping);
}

},{}],13:[function(require,module,exports){
"use strict";

var _ajaxHandler = _interopRequireDefault(require("../modules/ajax-handler"));

var _constants = require("../modules/_constants");

var _filter = require("./filter");

var _modal = require("./modal");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// import {setFormDefaults} from "./form";
var loadMoreBtns = document.querySelectorAll('[data-toggle="loadMore"]');

var loader = _modal.header.querySelector('.loader');

var loaderProgress = _modal.header.querySelector('.loader__progress');

var animation;
var start;

var progress = function progress(timestamp) {
  if (start === undefined) start = timestamp;
  var elapsed = timestamp - start;
  loaderProgress.style.width = elapsed / 15 + '%';

  if (elapsed < 900) {
    animation = window.requestAnimationFrame(progress);
  }
};

loadMoreBtns.forEach(function (loadMore) {
  var options = {
    'action': _constants.LOAD_MORE.action,
    'type': loadMore.dataset.type,
    'status': loadMore.dataset.status,
    'offset': loadMore.dataset.numberposts,
    'numberposts': loadMore.dataset.numberposts
  };
  var categoryTogglers = document.querySelectorAll('[data-toggle="category"]');
  var isFilter = loadMore.dataset.filter;
  var filterForm = document.querySelector('.form--filter');
  loadMore.addEventListener('click', function () {
    var ajaxHandler = new _ajaxHandler["default"]({
      'url': _constants.AJAX_URL,
      'btn': loadMore
    });
    var data = new FormData();

    for (var prop in options) {
      data.append(prop, options[prop]);
    }

    data.append('category', loadMore.dataset.category);
    start = undefined;
    loaderProgress.style.width = 0;
    setTimeout(function () {
      loader.classList.add('show');
      animation = window.requestAnimationFrame(progress);
    }, 200);

    if (isFilter && filterForm) {
      data.append('filters', JSON.stringify((0, _filter.getFilterFields)(filterForm))); // reset offset when filter is changed

      var controls = filterForm.querySelectorAll('select, input');
      controls.forEach(function (control) {
        return control.addEventListener('change', function () {
          return options.offset = loadMore.dataset.numberposts;
        });
      });
    } // reset offset when category is toggled


    categoryTogglers.forEach(function (toggler) {
      return toggler.addEventListener('change', function () {
        return options.offset = loadMore.dataset.numberposts;
      });
    });
    ajaxHandler.send(data, function () {
      loadMore.closest(_constants.LOAD_MORE.parent).querySelector(_constants.LOAD_MORE.container).insertAdjacentHTML('beforeend', ajaxHandler.response.cards);

      if (ajaxHandler.response) {
        window.cancelAnimationFrame(animation);
        setTimeout(function () {
          loaderProgress.style.width = '100%';
          loader.classList.remove('show');
        });
      }

      if (ajaxHandler.response.found_posts > ajaxHandler.response.post_count) {
        options.offset = ajaxHandler.response.post_count;
      } else {
        loadMore.style.display = 'none';
      }
    });
  });
});

},{"../modules/_constants":19,"../modules/ajax-handler":21,"./filter":8,"./modal":16}],14:[function(require,module,exports){
"use strict";

var _header = require("./header");

var dropdowns = document.querySelectorAll('[data-toggle="open-submenu"]');
var header = document.querySelector('.header');
dropdowns.forEach(function (item) {
  item.addEventListener('mouseover', function () {
    (0, _header.makeLightHeader)();
  });
});
header.addEventListener('mouseleave', function () {
  (0, _header.makeDarkHeader)();
});

var showMenu = function showMenu(menu, dropdown) {
  if (!menu.classList.contains('show')) {
    menu.classList.add('show');
    dropdown.classList.add('menu__link--active');
  }
};

var hideMenu = function hideMenu(menu, drop) {
  menu.classList.remove('show');
  drop.classList.remove('menu__link--active');
};

dropdowns.forEach(function (dropdown) {
  var parent = dropdown.closest('.menu__item');
  var currentMenu = parent.querySelector('.submenu');
  var closeBtn = currentMenu.querySelector('[data-toggle="close-submenu"]');
  dropdown.addEventListener('mouseenter', function () {
    showMenu(currentMenu, dropdown);
  });
  dropdown.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === 'Down') {
      showMenu(currentMenu, dropdown);
    }
  });
  parent.addEventListener('mouseleave', function () {
    hideMenu(currentMenu, dropdown);
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      hideMenu(currentMenu, dropdown);
    });
  }
});

},{"./header":11}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.menu = exports.closeMenu = void 0;

var _bodyScrollLock = require("body-scroll-lock");

// import { header } from './header';
var header = document.querySelector('.header');
var menu = document.getElementById('mobileMenu');
exports.menu = menu;
var body = document.body;
var mobileMenuBody = document.getElementById('mobile-menu-body');
var menuOpen = document.getElementById('mobileOpen');
var menuClose = document.getElementById('mobileClose');
var menuCloseModal = document.getElementById('mobileCloseModal');

var resetMobileMenu = function resetMobileMenu(e) {
  var sectionsTogglers = document.querySelectorAll('.accordion__toggler.active');
  var sections = document.querySelectorAll('.accordion__menu.collapse');
  sectionsTogglers.forEach(function (item) {
    item.classList.remove('active');
  });
  sections.forEach(function (item) {
    item.classList.remove('collapse');
  });
};

var closeMenu = function closeMenu(e) {
  body.classList.remove('modal-open');
  menu.classList.remove('show');
  menuOpen.classList.remove('open'); // menu.querySelector('.burger').classList.remove('open');

  var menuSectionShow = document.querySelector('.mobile-menu__section.show');
  setTimeout(function () {
    if (menuSectionShow) {
      menuSectionShow.classList.remove('show');
    } // if (menu.dataset.toplineShow) {
    //   header.classList.remove('header--gap');
    //   menu.dataset.toplineShow = '';
    // }


    (0, _bodyScrollLock.clearAllBodyScrollLocks)();
  }, 200);
  resetMobileMenu();
};

exports.closeMenu = closeMenu;

var closeMenuByOuterClick = function closeMenuByOuterClick(e) {
  var menuShow = document.querySelector('.mobile-wrapper.show');

  if (menuShow && !menuShow.contains(e.target) && !menuClose.contains(e.target) || e.target.classList.contains('mobile-overlay') || menuCloseModal.contains(e.target)) {
    closeMenu();
  }
};

menuOpen.addEventListener('click', function () {
  if (body.classList.contains('modal-open')) {
    closeMenu();
  } else {
    body.classList.add('modal-open');
    menuOpen.classList.add('open'); // if (window.innerWidth > 992) {
    //   // menu.dataset.toplineShow = '1';
    // }

    setTimeout(function () {
      menu.classList.toggle('show');
      (0, _bodyScrollLock.disableBodyScroll)(mobileMenuBody, {
        reserveScrollBarGap: true
      });
    }, 0);
    setMobileMenuHeights();
  }
});
window.addEventListener('click', closeMenuByOuterClick);

var setMobileMenuHeights = function setMobileMenuHeights() {
  var headerHeight = header.getBoundingClientRect().height;
  var footerHeight = menu.querySelector('.mobile-menu__footer').getBoundingClientRect().height;
  var bodyHeight = window.innerHeight - footerHeight - headerHeight;
  document.querySelector('.mobile-wrapper').style.height = window.innerHeight + headerHeight + 'px';
  mobileMenuBody.style.height = bodyHeight + 'px';
};

window.addEventListener('DOMContentLoaded', setMobileMenuHeights);
window.addEventListener('resize', setMobileMenuHeights);
var sectionToggler = document.querySelectorAll('[data-toggle="mobile-section"]');
sectionToggler.forEach(function (item) {
  item.addEventListener('click', function (e) {
    e.preventDefault();
    item.classList.toggle('active');
    item.parentElement.classList.toggle('show');
    item.nextElementSibling.classList.toggle('show');
  });
});

},{"body-scroll-lock":1}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.body = void 0;
exports.closeModal = closeModal;
exports.header = void 0;
exports.openModal = openModal;

var _constants = require("../modules/_constants");

var _functions = require("../modules/_functions");

var _form = require("./form");

var _bodyScrollLock = require("body-scroll-lock");

var openButtons = document.querySelectorAll('[data-toggle="modal"]') || [];
var closeButtons = document.querySelectorAll('[data-toggle="close-modal"]') || [];
var body = document.querySelector('body');
exports.body = body;
var header = document.querySelector('.header'); // let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

exports.header = header;

function closePopupByOuterClick(event) {
  if (!event.target.closest(_constants.MODAL.window) && !(event.target.getAttribute('data-toggle') === 'modal')) {
    closeModal();
  }
}

function openModal(id) {
  var modal = document.getElementById(id);
  modal.dispatchEvent(new CustomEvent('modal:beforeOpen'));

  if (!(0, _functions.isMobileDevice)()) {
    body.classList.add('lock'); // body.style.paddingRight = scrollbarWidth + 'px';
    // header.style.right = scrollbarWidth + 'px';
  }

  if ((0, _functions.isMobileDevice)()) {
    (0, _bodyScrollLock.disableBodyScroll)(modal, {
      reserveScrollBarGap: true
    });
  }

  setTimeout(function () {
    modal.classList.add('show');
    document.addEventListener('click', closePopupByOuterClick);
  }, 200);
}

function closeModal(modal) {
  modal = modal ? modal : document.querySelector('.modal.show');
  modal.classList.add('out');

  if ((0, _functions.isMobileDevice)()) {
    (0, _bodyScrollLock.enableBodyScroll)(modal);
  }

  setTimeout(function () {
    (0, _form.setFormDefaults)(false, modal);
    modal.classList.remove('show');
    modal.classList.remove('out');
    body.classList.remove('lock');
    body.style.paddingRight = null;
    header.style.right = null;
  }, 200);
  document.removeEventListener('click', closePopupByOuterClick);
}

openButtons.forEach(function (btn) {
  return btn.addEventListener('click', function (e) {
    e.preventDefault();
    var target = this.getAttribute('data-target').replace('#', '');
    openModal(target);
  });
});
closeButtons.forEach(function (btn) {
  return btn.addEventListener('click', function () {
    return closeModal();
  });
});
document.addEventListener('keydown', function (event) {
  var modal = document.querySelector('.modal.show');

  if (event.key === 'Escape' && modal) {
    closeModal(modal);
  }
});

},{"../modules/_constants":19,"../modules/_functions":20,"./form":9,"body-scroll-lock":1}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearStars = clearStars;

var _ajaxHandler = _interopRequireDefault(require("../modules/ajax-handler"));

var _constants = require("../modules/_constants");

var _jsCookie = _interopRequireDefault(require("js-cookie"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var stars = document.querySelectorAll('.stars-block:not(.disabled)');
stars.forEach(function (starsElement) {
  var starItems = starsElement.querySelectorAll('.stars-block__item');
  starsElement.addEventListener('mouseleave', starsMouseLeaveHandler);
  starItems.forEach(function (starItem) {
    starItem.addEventListener('mousemove', mouseMoveHandler);
    starItem.addEventListener('click', function () {
      var currRating = starsElement.closest('.rating');
      console.log(currRating);
      var input = currRating.querySelector('input[data-id="rating"]');
      var currValue = document.querySelector('[data-set-rating]');
      var text = starItem.dataset.text;
      input.value = starItem.dataset.rate;

      if (text) {
        starItem.setAttribute('voted', text);
        setTimeout(function () {
          return starItem.removeAttribute('voted');
        }, 0);
      }

      if (currValue) {
        currValue.innerHTML = starItem.dataset.rate;
      }

      var parent = starItem.closest('.rating');
      var state = {
        id: parent.dataset.id,
        type: parent.dataset.type,
        rating: starItem.dataset.rate
      };
      starsAjax(state);
    });
  });

  var starsAjax = function starsAjax(state) {
    var ajax = new _ajaxHandler["default"]({
      'url': _constants.AJAX_URL,
      'form': starsElement
    });
    var data = new FormData();
    data.append('action', _constants.RATING.action);
    data.append('csrf_token', document.getElementById('csrf-token').getAttribute('content'));
    data.append('type', state.type);
    data.append('id', state.id);
    data.append('rating', state.rating);
    data.append('page', window.location.href.split('?')[0]);
    ajax.send(data, function () {
      var response = ajax.response;

      if (response.status === 'success') {
        _jsCookie["default"].set('rated-post-' + state.id, state.rating, {
          expires: 365,
          path: '/'
        });

        document.querySelectorAll('.stars-block__item').forEach(function (star) {
          star.setAttribute('disabled', true);

          if (star.dataset.text) {
            star.setAttribute('tooltip', star.dataset.text);
          }
        });
        var rateCount = document.querySelector('.rate-count');
        var newRateCount = Number(rateCount.textContent) + 1;
        var rateAverage = document.querySelector('.average-rate');
        var newAverage = Number(rateAverage.textContent) * Number(rateCount.textContent) + Number(state.rating);
        newAverage = Math.round(newAverage / newRateCount * 10) / 10;
        rateCount.innerText = newRateCount;
        rateAverage.innerText = newAverage;
      }
    });
  };
});

function starsMouseLeaveHandler() {
  var ratingInput = this.closest('.rating').querySelector('input[data-id="rating"]');
  clearStars(this, false, ratingInput.value);
}

function mouseMoveHandler(e) {
  var rating = +this.dataset.rate;
  var starItems = this.closest('.stars-block').querySelectorAll('.stars-block__item');
  starItems.forEach(function (star) {
    var starOverlay = star.querySelector('.star-elem--inner');

    if (rating >= +star.dataset.rate) {
      starOverlay.style.width = '100%';
      starOverlay.classList.add('star-elem--full');
    } else {
      starOverlay.style.width = '0';
      starOverlay.classList.remove('star-elem--full');
    }
  });
}

function clearStars(stars, modal) {
  var currentRating = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
  var starsElement = stars ? stars : modal.querySelector('.stars-block');

  if (starsElement) {
    var starsItems = starsElement.querySelectorAll('.stars-block__item');
    starsItems.forEach(function (starItem) {
      var star = starItem.querySelector('.star-elem--inner');

      if (Number(starItem.dataset.rate) <= Number(currentRating)) {
        star.classList.add('star-elem--full');
      } else {
        star.classList.remove('star-elem--full');
      }
    });
    var input = starsElement.closest('.rating').querySelector('input[data-id="rating"]');
    input.value = currentRating;
  }
}

},{"../modules/_constants":19,"../modules/ajax-handler":21,"js-cookie":2}],18:[function(require,module,exports){
"use strict";

var sliders = document.querySelectorAll('.glide');
var reviews = document.querySelectorAll('.reviews');
var cards = document.querySelectorAll('.cards__slider');
var partners = document.querySelectorAll('.partners');
var gliders = [];
var reviewsArr = [];
var cardsArr = [];
var partnersArr = [];
sliders.forEach(function (slider) {
  var glide = new Glide('.glide', {
    type: 'carousel',
    autoplay: 4600,
    animationDuration: 1000,
    transitionType: 'fade',
    perView: 1
  });
  gliders.push(glide);
  glide.mount();
});
reviews.forEach(function () {
  var review = new Glide('.reviews', {
    type: 'carousel',
    perView: 1
  });
  reviewsArr.push(review);
  review.mount();
});

var mountSlider = function mountSlider(item) {
  var wrapSlides = item.querySelector('.glide__slides');

  if (wrapSlides === null) {
    wrapSlides = item.querySelector('.cards-row');
  }

  wrapSlides.classList.remove('cards-row');
  wrapSlides.classList.remove('cards-row--wrapped');
  wrapSlides.classList.remove('cards-row--init-1');
  wrapSlides.classList.add('glide__slides');
  var card = new Glide('.cards__slider', {
    type: 'slider',
    // focusAt: 'center',
    bound: true,
    perView: 4,
    gap: 20,
    startAt: 0,
    breakpoints: {
      1680: {
        perView: 3
      },
      1200: {
        perView: 2
      }
    }
  });
  cardsArr.push(card);
  card.mount();

  var detachSlider = function detachSlider() {
    card.destroy();
    wrapSlides.classList.remove('glide__slides');
    wrapSlides.classList.add('cards-row');
    wrapSlides.classList.add('cards-row--wrapped');
    wrapSlides.classList.add('cards-row--init-1');
  };

  return detachSlider;
};

var initSlider = function initSlider(item) {
  var detacher;
  var isMounted = false;

  var mounter = function mounter() {
    if (window.innerWidth > 768) {
      if (!isMounted) {
        detacher = mountSlider(item);
        isMounted = true;
      }
    } else {
      if (detacher) {
        detacher();
        detacher = undefined;
        isMounted = false;
      }
    }
  };

  mounter();
  window.addEventListener('resize', mounter);
};

cards.forEach(function (item) {
  initSlider(item);
});

var mountSliderPartner = function mountSliderPartner(item) {
  var wrapSlides = item.querySelector('.glide__slides');

  if (wrapSlides === null) {
    wrapSlides = item.querySelector('.cards-row');
  }

  wrapSlides.classList.remove('cards-row');
  wrapSlides.classList.remove('cards-row--wrapped');
  wrapSlides.classList.remove('cards-row--sm-3');
  wrapSlides.classList.add('glide__slides');
  var partner = new Glide('.partners', {
    type: 'slider',
    perView: 3,
    gap: 10,
    startAt: 0,
    breakpoints: {
      576: {
        perView: 2
      }
    }
  });
  partnersArr.push(partner);
  partner.mount();

  var detachSliderPartner = function detachSliderPartner() {
    partner.destroy();
    wrapSlides.classList.remove('glide__slides');
    wrapSlides.classList.add('cards-row');
    wrapSlides.classList.add('cards-row--wrapped');
    wrapSlides.classList.add('cards-row--sm-3');
  };

  return detachSliderPartner;
};

var initSliderPartner = function initSliderPartner(item) {
  var detacher;
  var isMounted = false;

  var mounter = function mounter() {
    if (window.innerWidth < 992) {
      if (!isMounted) {
        detacher = mountSliderPartner(item);
        isMounted = true;
      }
    } else {
      if (detacher) {
        detacher();
        detacher = undefined;
        isMounted = false;
      }
    }
  };

  mounter();
  window.addEventListener('resize', mounter);
};

partners.forEach(function (item) {
  initSliderPartner(item);
});

},{}],19:[function(require,module,exports){
"use strict";

module.exports = Object.freeze({
  AJAX_URL: '/wp/wp-admin/admin-ajax.php',
  LOAD_MORE: {
    action: 'load_more',
    parent: '.load-wrapper',
    container: '.load-container'
  },
  RATING: {
    action: 'set_rating'
  },
  FORM: {
    field: '.form__field',
    control: '.form__control',
    error: '.error-msg'
  },
  MODAL: {
    module: '.modal',
    window: '.modal__popup',
    content: '.modal__content',
    response: '.modal__response',
    footer: '.modal__footer',
    successId: 'modal-success'
  },
  SELECT: {
    classes: {
      'main': 'select',
      'list': 'select__list',
      'current': 'select__current',
      'optionSelected': 'active'
    }
  },
  HOURS_IN_MONTH: 720,
  SUCCESS_PAGE: '/success/'
});

},{}],20:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.getSiblings = getSiblings;
exports.inViewport = inViewport;
exports.isMobileDevice = isMobileDevice;
exports.numberThousandSeparator = numberThousandSeparator;

/**
 * @param {String} data
 *
 * @return {String}
 */
var _default = Element.prototype.data = function (data) {
  return this.getAttribute('data-' + data);
};
/**
 * @return {Boolean}
 */


exports["default"] = _default;

function isMobileDevice() {
  return typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1;
}
/**
 * @param {Element} element
 *
 * @return {Boolean}
 */


function inViewport(element) {
  return !(element.getBoundingClientRect().top > innerHeight || element.getBoundingClientRect().bottom < 0);
}
/**
 * @param {Element} element
 *
 * @return {Array}
 */


function getSiblings(element) {
  return Array.prototype.filter.call(element.parentNode.children, function (sibling) {
    return sibling !== element;
  });
}
/**
 * @param {Number} n
 *
 * @return {String}
 */


function numberThousandSeparator(n) {
  return n.toString().replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 ');
}

},{}],21:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var AjaxHandler = /*#__PURE__*/function () {
  function AjaxHandler(options) {
    _classCallCheck(this, AjaxHandler);

    this.options = options;
    this.form = this.options.form;
    this.btn = this.form ? this.form.querySelector('button[type="submit"]') : this.options.btn ? this.options.btn : null;
  }

  _createClass(AjaxHandler, [{
    key: "onResponseSuccess",
    value: function onResponseSuccess(callback) {
      if (callback) {
        callback();
      }
    }
  }, {
    key: "onResponseFalse",
    value: function onResponseFalse(callback) {
      if (callback) {
        callback();
      }
    }
  }, {
    key: "onAjaxHandlerProcess",
    value: function onAjaxHandlerProcess(callback) {
      if (callback) {
        callback();
      }
    }
  }, {
    key: "send",
    value: function send(data, callbackSuccess, callbackFalse, callbackProcess) {
      var _this = this;

      // Event to modify data before ajax sending
      var beforeSubmitEvent;
      var xhr = new XMLHttpRequest();

      if (this.form) {
        beforeSubmitEvent = new CustomEvent('ajax:beforeSubmit', {
          'detail': {
            formData: data
          }
        });
        this.form.dispatchEvent(beforeSubmitEvent);
      }

      xhr.open('POST', this.options.url, true);
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.send(beforeSubmitEvent ? beforeSubmitEvent.detail.formData : data); // this._disableBtn();

      this._loadingBtn();

      xhr.onreadystatechange = function () {
        if (xhr.readyState === xhr.DONE && xhr.status === 200) {
          setTimeout(function () {
            var response;

            try {
              response = JSON.parse(xhr.responseText);
            } catch (e) {
              response = xhr.responseText;
            } // this._enableBtn();


            _this._activateBtn();

            _this.response = response;

            if (response.status === 'error') {
              _this.onResponseFalse(callbackFalse);
            } else {
              _this.onResponseSuccess(callbackSuccess);
            }
          }, 1000);
        }
      };
    }
  }, {
    key: "_disableBtn",
    value: function _disableBtn() {
      if (this.btn) {
        this.btn.setAttribute('disabled', 'disabled');
      }
    }
  }, {
    key: "_enableBtn",
    value: function _enableBtn() {
      if (this.btn) {
        this.btn.removeAttribute('disabled');
      }
    }
  }, {
    key: "_loadingBtn",
    value: function _loadingBtn() {
      if (this.btn) {
        this.btn.classList.add('loading');
      }
    }
  }, {
    key: "_activateBtn",
    value: function _activateBtn() {
      if (this.btn) {
        this.btn.classList.remove('loading');
      }
    }
  }]);

  return AjaxHandler;
}();

var _default = AjaxHandler;
exports["default"] = _default;

},{}],22:[function(require,module,exports){
"use strict";

window.dataLayer = window.dataLayer || [];

window.gtag = function () {
  dataLayer.push(arguments);
};
/**
 * @param {String} ymGoal
 * @param {String} gadsGoal
 * @param {Object} ga4Goal
 */


module.exports.reachGoals = function (ymGoal, gadsGoal, ga4Goal) {
  var ymCounterTag = document.getElementById('yandex-counter');
  var ymCounterNumber = ymCounterTag ? ymCounterTag.getAttribute('content') : '';
  var ym = 'yaCounter' + ymCounterNumber;
  var gadsIdTag = document.getElementById('google-ads-id');
  var gadsId = gadsIdTag ? gadsIdTag.getAttribute('content') : '';

  if (typeof ymCounterNumber !== 'undefined' && typeof window[ym] !== 'undefined' && ymCounterNumber.length && typeof ymGoal !== 'undefined') {
    window[ym].reachGoal(ymGoal);
  }

  if (typeof gtag !== 'undefined' && typeof ga4Goal !== 'undefined' && ga4Goal.id !== '') {
    var $params = {};

    if (ga4Goal.params) {
      ga4Goal.params.forEach(function (param) {
        $params[param.key] = param.type === 'number' ? Number(param.value) : param.value;
      });
    }

    gtag("event", ga4Goal.id, $params);
  }

  if (typeof gtag !== 'undefined' && typeof gadsGoal !== 'undefined' && gadsGoal.length && gadsId !== '') {
    gtag('event', 'conversion', {
      'send_to': gadsId + '/' + gadsGoal
    });
  }
};

},{}],23:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var GreatSelect = /*#__PURE__*/function () {
  /**
   * @param {String} itemsSelector
   * @param {Object} options
   */
  function GreatSelect(itemsSelector, options) {
    _classCallCheck(this, GreatSelect);

    this.classes = {
      'main': 'great-select',
      'opened': 'open',
      'disabled': 'disabled',
      'list': 'list',
      'option': 'option',
      'current': 'current',
      'optionSelected': 'selected',
      'optionFocused': 'focus'
    };

    if (options && options.classes) {
      for (var optionClass in options.classes) {
        this.classes[optionClass] = options.classes[optionClass];
      }
    }

    this.selectItems = document.querySelectorAll(itemsSelector);
  }

  _createClass(GreatSelect, [{
    key: "init",
    value: function init() {
      var _this = this;

      //this._removeListeners();
      GreatSelect._iePointerEventsFix();

      this.selectItems.forEach(function (item) {
        var nextElement = item.nextElementSibling;
        item.style.display = 'none';

        if (!nextElement || nextElement && !nextElement.classList.contains(_this.classes.main)) {
          _this._createSelect(item);
        }
      });

      this._addGlobalListeners();
    }
  }, {
    key: "_createSelect",
    value: function _createSelect(selectItem) {
      var _this2 = this;

      var selectDisabled = selectItem.getAttribute('disabled');
      var selectContainer = '<div class="' + this.classes.main + ' great-select ' + (selectItem.getAttribute('class') || '') + (selectDisabled ? this.classes.disabled : '') + '" ' + '' + (!selectDisabled ? 'tabindex="0"' : '') + '>' + '<span class="' + this.classes.current + '"></span>' + '<ul class="' + this.classes.list + '"></ul>' + '</div>';
      selectItem.insertAdjacentHTML('afterend', selectContainer);
      var dropdown = selectItem.nextElementSibling;
      var options = selectItem.querySelectorAll('option');
      var selectedOption = selectItem.querySelector('option:checked');
      var optionsContainer = dropdown.querySelector('ul');
      var icon = selectedOption.getAttribute('data-select-icon');
      dropdown.querySelector('.' + this.classes.current).innerHTML = "".concat(icon ? "<span class=\"select__icon\"><img src=\"".concat(icon, "\" alt=\"\"></span>") : '', " ").concat(selectedOption.getAttribute('data-display') || selectedOption.getAttribute('data-shorter-name') || selectedOption.textContent);
      options.forEach(function (option) {
        var displayText = option.getAttribute('data-display');
        var shorterName = option.getAttribute('data-shorter-name');
        var icon = option.getAttribute('data-select-icon');
        var optionItem = "<li data-value=\"".concat(option.value, "\" data-select-icon=\"").concat(icon, "\" \n          ").concat(displayText ? 'data-display="' + displayText + '"' : '', "\n          ").concat(shorterName ? 'data-shorter-name="' + shorterName + '"' : '', "\n          class=\"").concat(_this2.classes.option, " ").concat(option.selected ? _this2.classes.optionSelected : '', " ").concat(option.disabled ? _this2.classes.disabled : '', "\">\n          ").concat(icon ? "<span class=\"select__icon\"><img src=\"".concat(icon, "\" alt=\"\"></span>") : '', "\n          <span>").concat(option.textContent, "</span>\n          </li>");
        optionsContainer.insertAdjacentHTML('beforeend', optionItem);
      });

      this._addSelectListeners(selectItem.nextElementSibling, selectItem.previousElementSibling);
    }
  }, {
    key: "_removeListeners",
    value: function _removeListeners() {
      var allSelects = document.querySelectorAll('.' + this.classes.main);
      allSelects.forEach(function (select) {
        var clone = select.cloneNode(true);
        select.parentNode.replaceChild(clone, select);
      });
    }
  }, {
    key: "_addSelectListeners",
    value: function _addSelectListeners(gSelectItem, label) {
      var _this3 = this;

      gSelectItem.addEventListener('click', function (e) {
        var dropdown = e.target.closest('.' + _this3.classes.main);
        document.querySelectorAll('.' + _this3.classes.main).forEach(function (item) {
          if (item !== dropdown) {
            item.classList.remove(_this3.classes.opened);
          }
        });
        dropdown.classList.toggle(_this3.classes.opened);

        if (dropdown.classList.contains(_this3.classes.opened)) {
          var focusedOption = dropdown.querySelector('.' + _this3.classes.optionFocused);

          if (focusedOption) {
            focusedOption.classList.remove(_this3.classes.optionFocused);
          }

          dropdown.querySelector('.' + _this3.classes.optionSelected).classList.add(_this3.classes.optionFocused);
        } else {
          dropdown.focus();
        }
      });
      var activeOptions = gSelectItem.querySelectorAll('.' + this.classes.option + ':not(.' + this.classes.disabled + ')');
      activeOptions.forEach(function (option) {
        return option.addEventListener('click', function (e) {
          var targetOption = e.target.closest('.' + _this3.classes.option);
          var icon = option.getAttribute('data-select-icon');
          gSelectItem.querySelector('.' + _this3.classes.optionSelected).classList.remove(_this3.classes.optionSelected);
          targetOption.classList.add(_this3.classes.optionSelected);
          gSelectItem.querySelector('.' + _this3.classes.current).innerHTML = "".concat(icon ? "<span class=\"select__icon\"><img src=\"".concat(icon, "\" alt=\"\"></span>") : '', " ").concat(targetOption.getAttribute('data-display') || targetOption.getAttribute('data-shorter-name') || targetOption.textContent);
          gSelectItem.previousElementSibling.value = targetOption.getAttribute('data-value');
          gSelectItem.previousElementSibling.dispatchEvent(new CustomEvent('change'));
        });
      });
      gSelectItem.addEventListener('keydown', function (e) {
        var targetDropdown = e.target.closest('.' + _this3.classes.main);
        var focusedOption = targetDropdown.querySelector('.' + _this3.classes.optionFocused) || targetDropdown.querySelector('.' + _this3.classes.option + '.' + _this3.classes.optionSelected);

        if (e.code === 'Space' || e.code === 'Enter') {
          e.preventDefault();

          if (targetDropdown.classList.contains(_this3.classes.opened)) {
            focusedOption.click();
          } else {
            targetDropdown.click();
          }
        } else if (e.code === 'ArrowDown') {
          e.preventDefault();

          if (!targetDropdown.classList.contains(_this3.classes.opened)) {
            targetDropdown.click();
          } else {
            //TODO: find next not disabled
            //var $next = $focused_option.nextAll('.option:not(.disabled)').first();
            // let nextAll = false;
            // nextAll = [].filter.call(focusedOption.parentNode.children,  elem => {
            //     return (elem.previousElementSibling === focusedOption) ? nextAll = true : nextAll;
            // });
            var next = focusedOption.nextElementSibling;

            if (next) {
              targetDropdown.querySelector('.' + _this3.classes.optionFocused).classList.remove(_this3.classes.optionFocused);
              next.classList.add(_this3.classes.optionFocused);
            }
          }
        } else if (e.code === 'ArrowUp') {
          e.preventDefault();

          if (!targetDropdown.classList.contains(_this3.classes.opened)) {
            targetDropdown.click();
          } else {
            //TODO: find prev not disabled
            var prev = focusedOption.previousElementSibling;

            if (prev) {
              targetDropdown.querySelector('.' + _this3.classes.optionFocused).classList.remove(_this3.classes.optionFocused);
              prev.classList.add(_this3.classes.optionFocused);
            }
          }
        } else if (e.code === 'Escape') {
          targetDropdown.classList.remove(_this3.classes.opened);
        } else if (e.code === 'Tab') {
          if (targetDropdown.classList.contains(_this3.classes.opened)) {
            e.preventDefault();
          }
        }
      });
      label.addEventListener('click', function () {
        gSelectItem.focus();
      });
    }
  }, {
    key: "_addGlobalListeners",
    value: function _addGlobalListeners() {
      var _this4 = this;

      document.addEventListener('click', function (e) {
        var openedSelect = document.querySelector('.' + _this4.classes.main + '.' + _this4.classes.opened);

        if (openedSelect && !openedSelect.contains(e.target)) {
          openedSelect.classList.remove(_this4.classes.opened);
        }
      });
    }
  }, {
    key: "update",
    value: function update() {
      var _this5 = this;

      this.selectItems.forEach(function (select) {
        var dropdown = select.nextElementSibling;
        var opened = dropdown.classList.contains(_this5.classes.opened);

        if (dropdown && dropdown.classList.contains(_this5.classes.main)) {
          dropdown.remove();

          _this5._createSelect(select);

          if (opened) {
            select.nextElementSibling.click();
          }
        }
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this6 = this;

      this.selectItems.forEach(function (select) {
        var dropdown = select.nextElementSibling;

        if (dropdown && dropdown.classList.contains(_this6.classes.main)) {
          dropdown.remove();
          select.style.display = '';
        }
      });
    }
  }], [{
    key: "_iePointerEventsFix",
    value: function _iePointerEventsFix() {
      // Detect CSS pointer-events support, for IE <= 10. From Modernizr.
      var style = document.createElement('a').style;
      style.cssText = 'pointer-events:auto';

      if (style.pointerEvents !== 'auto') {
        document.querySelector('html').classList.add('no-csspointerevents');
      }
    }
  }]);

  return GreatSelect;
}();

exports["default"] = GreatSelect;

},{}]},{},[3]);
